// Insert `text` into a text field's value at its caret (or replace the
// selection), returning the new value and where the caret should land.
export function insertAtCursor(
  el: HTMLInputElement | HTMLTextAreaElement | null,
  value: string,
  text: string,
): { value: string; caret: number } {
  const start = el?.selectionStart ?? value.length;
  const end = el?.selectionEnd ?? value.length;
  return {
    value: value.slice(0, start) + text + value.slice(end),
    caret: start + text.length,
  };
}
